export default "__VITE_ASSET__ed502741__"